import { render, staticRenderFns } from "./CamposIntegracaoDinamicos.vue?vue&type=template&id=74c7824d"
import script from "./CamposIntegracaoDinamicos.vue?vue&type=script&lang=js"
export * from "./CamposIntegracaoDinamicos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports